export interface NavigationItem {
  path: string;
  label: string;
  labelEn: string;
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { path: '/', label: 'ホーム', labelEn: 'HOME' },
  { path: '/company', label: '会社概要', labelEn: 'COMPANY' },
  { path: '/service', label: 'サービス', labelEn: 'SERVICE' },
  { path: '/kampo', label: '漢方講座', labelEn: 'KAMPO' },
  { path: '/shichusuimei', label: '四柱推命', labelEn: 'SHICHUSUIMEI' },
  { path: '/contact', label: 'お問い合わせ', labelEn: 'CONTACT' },
];
